// ======================================================================
// FILE:
// src/modules/finance/transactions/payables/services/payablesService.js
// ======================================================================

import axiosClient from "../../../../../api/axiosClient";


// ======================================================================
// API BASE URL
// ======================================================================

const BASE_URL =
    "/api/finance/payables";


// ======================================================================
// LIST PAYABLES
// ======================================================================

/**
 * ----------------------------------------------------------------------
 * LIST OUTSTANDING PAYABLES
 * ----------------------------------------------------------------------
 *
 * Backend:
 * GET /api/finance/payables
 *
 * Returns:
 * - Posted Purchase Invoices
 * - Outstanding payable amount
 * - Allocated/paid amount
 * - Payment status
 *
 * The page is responsible for UI/state handling.
 * This service only communicates with the backend.
 * ----------------------------------------------------------------------
 */

async function listPayables() {

    const response =
        await axiosClient.get(
            BASE_URL
        );

    const data =
        response?.data?.data;

    if (Array.isArray(data)) {
        return data;
    }

    return (
        data?.rows ||
        data?.items ||
        data?.data ||
        []
    );
}

// ======================================================================
// LIST VENDOR ADVANCE PAYABLES
// ======================================================================

/**
 * ----------------------------------------------------------------------
 * LIST OUTSTANDING VENDOR ADVANCES
 * ----------------------------------------------------------------------
 *
 * Backend:
 * GET /api/finance/payables/vendor-advances
 *
 * Returns:
 * - Vendor Advance obligations
 * - Advance amount
 * - Paid amount
 * - Adjusted amount
 * - Outstanding amount
 * ----------------------------------------------------------------------
 */

async function listVendorAdvancePayables() {

    const response =
        await axiosClient.get(
            `${BASE_URL}/vendor-advances`
        );

    const data =
        response?.data?.data;

    if (Array.isArray(data)) {
        return data;
    }

    return (
        data?.rows ||
        data?.items ||
        data?.data ||
        []
    );
}

// ======================================================================
// GET PAYABLE DETAIL
// ======================================================================

async function getPayable(
    purchaseInvoiceId
) {

    const response =
        await axiosClient.get(
            `${BASE_URL}/${purchaseInvoiceId}`
        );

    return response?.data?.data || null;
}

async function createPaymentForPayable(
    purchaseInvoiceId,
    payload
) {
    const response =
        await axiosClient.post(
            `${BASE_URL}/${purchaseInvoiceId}/payment`,
            payload
        );

    return response?.data?.data || null;
}


async function createPaymentForTransportPayable(
    transportVehicleId,
    payload
) {
    const response =
        await axiosClient.post(
            //`${BASE_URL}/transport/${transportRequestId}/payment`,
            `/api/finance/payables/transport/${transportVehicleId}/payment`,
            payload
        );

    return response?.data?.data || null;
}

// ======================================================================
// LIST VENDOR ADVANCES AVAILABLE FOR PURCHASE INVOICE ADJUSTMENT
// ======================================================================

async function listAdjustableVendorAdvances(
    purchaseInvoiceId
) {
    const response =
        await axiosClient.get(
            `${BASE_URL}/${purchaseInvoiceId}/adjustable-vendor-advances`
        );

    const data =
        response?.data?.data;

    if (Array.isArray(data)) {
        return data;
    }

    return [];
}


// ======================================================================
// CREATE VENDOR ADVANCE ADJUSTMENT
// ======================================================================

async function createVendorAdvanceAdjustment(
    vendorAdvanceId,
    payload
) {
    const response =
        await axiosClient.post(
            `${BASE_URL}/vendor-advances/${vendorAdvanceId}/adjust`,
            payload
        );

    return response?.data?.data || null;
}


// ======================================================================
// LIST TRANSPORT PAYABLES
// ======================================================================

async function listTransportPayables() {
    const response = await axiosClient.get(
        `${BASE_URL}/transport`
    );

    const data = response?.data?.data;

    if (Array.isArray(data)) {
        return data;
    }

    return (
        data?.rows ||
        data?.items ||
        data?.data ||
        []
    );
}


async function createPaymentForVendorAdvance(
    vendorAdvanceId,
    payload
) {
    const response =
        await axiosClient.post(
            `${BASE_URL}/vendor-advances/${vendorAdvanceId}/payment`,
            payload
        );

    return response?.data?.data || null;
}

// ======================================================================
// EXPORTS
// ======================================================================

export {
    listPayables,
    listVendorAdvancePayables,
    listTransportPayables,
    getPayable,
    createPaymentForPayable,
    createPaymentForTransportPayable,

    createPaymentForVendorAdvance,
    createVendorAdvanceAdjustment,
    listAdjustableVendorAdvances,
};